
import { withCompController } from '@wix/editor-elements-integrations';
import type {
  IMenuListProps,
  IMenuListMapperProps,
  IMenuListControllerProps,
  IMenuListStateValues,
} from '../../../components/MenuList/MenuList.props';

export default withCompController<
  IMenuListMapperProps,
  IMenuListControllerProps,
  IMenuListProps,
  IMenuListStateValues
>(({ mapperProps, controllerUtils, stateValues }) => {
  const { editorType } = stateValues
  return {
    ...mapperProps,
    editorType,
    updateComponentPropsInViewer: props => {
      controllerUtils.updateProps(props);
    }
  }
});
